import React, { useState, useEffect } from "react"

//controls
import { Button, Col, Form, Input, Label, Row, FormFeedback } from "reactstrap"
import Switch from "react-switch"

//react form
import { FormProvider, useForm, Controller } from "react-hook-form"

//navigation
import { Link, useNavigate, useParams } from "react-router-dom"

//validation
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"

//redux
import { useSelector, useDispatch } from "react-redux"

import { isEmpty } from "lodash"
//custom hooks
import { useDeepCompareEffect } from "hooks"
import { updateBasicSettings as OnUpdateBasicSettings } from "store/actions"
import { OnSymbol, Offsymbol } from "helpers/switch_helper"

const formdefault = {
  PayPalBaseUrl: "",
  PayPalClientID: "",
  PayPalSecretKey: "",
  EnablePaypal: false,
}
function PaypalTab() {
  const dispatch = useDispatch()
  const { basicSetting } = useSelector(state => state.Layout)
  /**
   * Form Validation Schema
   */
  const schema = yup.object().shape({
    PayPalBaseUrl: yup.string().nullable(),
    PayPalClientID: yup.string().nullable(),
    PayPalSecretKey: yup.string().nullable(),
    EnablePaypal: yup.bool(),
  })

  const methods = useForm({
    mode: "onChange",
    defaultValues: formdefault,
    resolver: yupResolver(schema),
  })
  const { reset, control, formState, setValue, getValues, trigger } = methods
  const { errors, isValid } = formState

  useDeepCompareEffect(() => {
    function updatePaypalState() {
      //reset form with server data
      if (basicSetting) {
        const response = {
          ...basicSetting,
        }
        reset(response)
      }
    }

    updatePaypalState()
  }, [dispatch, basicSetting])

  const handleSave = () => {
    trigger() //for form validation
    if (isValid) {
      dispatch(OnUpdateBasicSettings({ ...getValues(), BasicSettingID: 1 }))
      //reset(formdefault)
    }
  }

  return (
    <FormProvider {...methods}>
      <Row>
        <Col lg={6}>
          <div className="mb-3">
            <Label>PayPal Base Url</Label>
            <Controller
              name="PayPalBaseUrl"
              control={control}
              render={({ field }) => (
                <>
                  <Input {...field} id="PayPalBaseUrl" type="text" />
                </>
              )}
            />
          </div>
          <div className="mb-3">
            <Label>PayPal Client ID</Label>
            <Controller
              name="PayPalClientID"
              control={control}
              render={({ field }) => (
                <>
                  <Input {...field} id="PayPalClientID" type="text" />
                </>
              )}
            />
          </div>
          <div className="mb-3">
            <Label>PayPal Secret Key</Label>
            <Controller
              name="PayPalSecretKey"
              control={control}
              render={({ field }) => (
                <>
                  <Input
                    {...field}
                    id="PayPalSecretKey"
                    type="text"
                    value={field.value || ""}
                  />
                </>
              )}
            />
          </div>

          <div className="mb-3">
            <Label>Enable</Label>
            <div>
              <Controller
                name="EnablePaypal"
                control={control}
                render={({ field }) => (
                  <>
                    <Switch
                      {...field}
                      id="EnablePaypal"
                      checked={field.value}
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      className="me-1 mb-sm-8 mb-2"
                      onColor="#626ed4"
                    />
                  </>
                )}
              />
            </div>
          </div>
        </Col>
      </Row>
      <div className="d-flex flex-wrap gap-2">
        <Button color="primary" className="btn" onClick={handleSave}>
          {"Save"}
        </Button>
      </div>
    </FormProvider>
  )
}
export default PaypalTab
